import React, { useMemo } from 'react';
import {
 Box,
 Text,
 Button,
 Flex,
 Portal,
 Container,
 Center,
 Stack,
} from '@chakra-ui/react';
import HeaderProgress from './HeaderProgress';
import QuestionnaireHeader from './QuestionnaireHeader';
import CertificationSurveyReplica from './CertificationSurveyReplica';
import { totalIndicadores, indicadoresRespondidos } from '../../helpers/medidasGri';

const RespondentViewReplica = ({
 defaultValues,
 surveyId,
 companyId,
 userId,
 questions,
 companyName,
 description,
 totalAnsweredQuestions,
 requiredQuestionsCount,
 answeredRequiredQuestionsCount,
 onClose,
 submissionDate,
 replicaData,
 isReplicable,
}) => {
 const totalQuestionsCount = questions?.length || 0;
 const totalIndicators = totalIndicadores(questions);
 const answeredIndicators = indicadoresRespondidos(questions, companyId);

 // Memo para estruturar os defaultValues por surveyId
 const structuredDefaultValues = useMemo(() => {
  // Para questionário principal
  const mainValues = {
    [surveyId]: defaultValues?.[surveyId] || {}
  };

  // Para réplicas se existirem
  const replicaValues = replicaData?.reduce((acc, replica) => {
    if (replica?.survey?.id_survey) {
      acc[replica.survey.id_survey] = defaultValues?.[replica.survey.id_survey] || {};
    }
    return acc;
  }, {});

  return {
    ...mainValues,
    ...replicaValues
  };
 }, [defaultValues, surveyId, replicaData]);

 return (
  <Portal>
   <Box
    position='fixed'
    top={0}
    left={0}
    right={0}
    bottom={0}
    zIndex={9999}
    bg='white'
    overflowY='auto'
    css={{
     '&::-webkit-scrollbar': {
      width: '8px',
     },
     '&::-webkit-scrollbar-track': {
      width: '10px',
     },
     '&::-webkit-scrollbar-thumb': {
      background: '#C4C4C4',
      borderRadius: '24px',
     },
    }}
   >
    <Box position='fixed' top={0} left={0} right={0} zIndex={10000} h='44px' bg='#FBDED5'>
     <Center h='100%' px='86px'>
      <Flex w='100%' maxW='1280px' justify='space-between' align='center'>
       <Text fontSize='sm' color='#EA582B' fontWeight='500'>
        <b>Atenção:</b> Você está no modo visualização do respondente. Neste modo, nenhuma
        ação é permitida.
       </Text>
       <Button
        variant='link'
        color='#EA582B'
        fontSize='15px'
        textDecor='underline'
        fontWeight='600'
        onClick={onClose}
        _hover={{ textDecor: 'underline' }}
       >
        Sair do modo visualização
       </Button>
      </Flex>
     </Center>
    </Box>

    <Container bg='#F5F5FB' maxW='100vw' minH='101vh' overflowX='hidden' p={0}>
     <QuestionnaireHeader
      tagLabel={companyName}
      heading={description}
      totalQuestions={`${totalQuestionsCount} perguntas`}
      overline
     >
      <HeaderProgress
       totalQuestions={totalQuestionsCount}
       totalAnsweredQuestions={totalAnsweredQuestions}
       requiredQuestions={requiredQuestionsCount}
       answeredRequiredQuestions={answeredRequiredQuestionsCount}
       totalIndicators={totalIndicators}
       answeredIndicators={answeredIndicators}
      />
      <Stack spacing='12px' ml='auto'>
       <Button isDisabled variant='primary' width='300px' height='49px'>
        Enviar respostas
       </Button>
       <Flex gap='12px'>
        <Button variant='cancel' width='144px' height='49px'>
         Voltar
        </Button>
        <Button
         type='submit'
         variant='outline'
         color='#0073BB'
         borderColor='#0073BB'
         isDisabled
         width='144px'
         height='49px'
         pointerEvents='auto'
        >
         Salvar
        </Button>
       </Flex>
      </Stack>
     </QuestionnaireHeader>

     {submissionDate && (
      <Box maxW='1280px' mx='auto' p='4' color='#0073BB' fontSize='sm'>
       O questionário foi enviado no dia {submissionDate}
      </Box>
     )}

     <Center mt={['8px', '6']} pb={['100px', '32px']} px={{ xl: '86px', '2xl': 'unset' }}>
      <Container maxW='1280px' p={0}>
       <Box bg='white' p='6' borderRadius='12px'>
        <CertificationSurveyReplica
         defaultValues={structuredDefaultValues}
         surveyId={surveyId}
         companyId={companyId}
         userId={userId}
         questions={questions}
         isViewMode={true}
         handleSuccess={() => {}}
         replicaData={replicaData}
         isReplicable={isReplicable}
        />
       </Box>
      </Container>
     </Center>
    </Container>
   </Box>
  </Portal>
 );
};

export default RespondentViewReplica;